import Modal from 'apollo-react/components/Modal';
import React from 'react';

import { useTranslation } from '../custom-hooks/useTranslation';

const DeleteConfirmationModal = ({ open, onClose, onDeleteConfirm, message }) => {
  const translateString = useTranslation();

  const messageToDisplay = message || translateString('Do you really want to delete?');

  return (
    <Modal
      open={open}
      onClose={onClose}
      title={translateString('Confirm Delete')}
      variant="warning"
      buttonProps={[
        {
          label: translateString('Delete'),
          variant: 'primary',
          onClick: onDeleteConfirm,
        },
      ]}
    >
      <p>{messageToDisplay}</p>
    </Modal>
  );
};

export default DeleteConfirmationModal;
